import { MobileLayoutNodeDefinition } from './services/layout';
import { ComponentType } from 'react';

export type DAFTComponent<T extends MobileLayoutNodeDefinition<any>> = ComponentType<{
    path: string;
    definition: T;
}>;

class ControlRegistry {
  public registry: { [name: string]: DAFTComponent<any> } = {};

  public registerComponent(name: string, component: DAFTComponent<any>) {
    this.registry[name] = component;
  };

  public getComponent(name: string) {
    return this.registry[name];
  };
}

export const registry = new ControlRegistry();
